if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

const elements = document.getElementsByClassName("gift__card-overlay");
const giftCardAdd = document.getElementById("giftCardAdd");
const modalButton = document.getElementsByClassName("card__button");
const closeButton = document.querySelector(".gift__card-close");

function addGiftCard(element) {
  var modal = element.getAttribute("data-title");
  for (let i = 0; i < elements.length; i++) {
    if(elements[i].classList.contains(modal)) {
      elements[i].classList.add('open_overlay');
    }
  }
};

function giftSelectChange(element) {
  const variant = element.value;
  if (variant) {
    element.classList.remove("no-selected");
    element.previousElementSibling.value = variant;
  } else {
    element.classList.add("no-selected");
  }

  const variantSelected = element.getAttribute("data-value");
  if (variantSelected) {
    document.querySelector(".input-select").value = variantSelected;
    document.querySelectorAll(".greeting-card__option").forEach((e) => {
      e.classList.remove("option-selected")
    })
    element.classList.add("option-selected")
  }

  const indexVariant = element.getAttribute("data-index");
  const indexImage = document.querySelectorAll(".greeting-card__image img");
  indexImage.forEach((e) => {
    e.setAttribute("aria-hidden", "true");
    if(e.getAttribute("data-index") == indexVariant) {
      e.setAttribute("aria-hidden", "false"); 
    }
  })

  element.closest(".form-greeting-card").classList.add("is-selected");
}

if (document.querySelector(".button-clear")) {
  document.querySelector(".button-clear").addEventListener("click", () => {
    document.querySelector("#greeting-card-message").value = "";
    document.querySelector("#greeting-card-message").placeholder = "Write your message...";
  })
}

if (document.querySelectorAll(".gift__card-close")) {
  document.querySelectorAll(".gift__card-close").forEach((e) => {
    e.addEventListener("click", closeModals);
  })
}

Array.from(modalButton).forEach(function(element) {
  element.addEventListener('click', closeModals);
});

function closeModals() {
  for (let i = 0; i < elements.length; i++) {
     elements[i].classList.remove('open_overlay');
  }
}

Array.from(elements).forEach(function(element) {
  element.addEventListener('click', function (e) {
    if (e.target.classList.contains('gift__card-overlay')) {
     closeModals();
    }
  });
})

